import { observer } from 'mobx-react-lite';
import OptionList from '@/pages/price-enduser/components/option';
import OtherSettingList from '@/pages/price-enduser/components/other-setting';
import WreckerPrice from '@/pages/price-enduser/components/other-option/WreckerPrice';
import CancellationFee from '@/pages/price-enduser/components/other-option/CancellationFee';
import RentalFee from '../components/RentalFee';

export default observer(function PriceTab() {
    return (
        <div className='flex flex-col gap-[min(60px,10vw)]'>
            <RentalFee />
            <CancellationFee
                showTextDecoration={false}
                showDescription={false}
            />
            <OptionList />
            <OtherSettingList />
            <WreckerPrice />
        </div>
    );
});
